import { render, staticRenderFns } from "./AddEditImage.vue?vue&type=template&id=4298d29e&"
import script from "./AddEditImage.vue?vue&type=script&lang=js&"
export * from "./AddEditImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports